<!-- <div *ngIf="item" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0 tile" (click)="redirect($event, item)">
	<img [src]="image" alt="" onError="this.src='./assets/images/dummy/placeholderImage.jpg'" />
	<h3 class="name">{{ item.name }}</h3>
	<div class="col-xs-12 col-sm-12 col-md-12 px-0">
		<p class="price-label">
			<span *ngIf="getPrice(item)[1]" for="finalDiscountedPrice">{{getPrice(item)[1] |
				currency:'INR':'symbol-narrow':'1.2-2'}}</span>
			<span [class.strikeThrough]="getPrice(item)[1]" for="finalActualPrice">{{getPrice(item)[0] |
				currency:'INR':'symbol-narrow':'1.2-2'}}</span>
		</p>
	</div> -->
<!-- <p class="by-info" *ngIf="item.description">{{item.description}}</p> -->
<!-- <div class="col-xs-12 col-sm-12 col-md-12 px-0 brandDetail">
		<p class="by-info" *ngIf="item?.brand?.name">
			{{getShortenedBrandName(item?.brand?.name || '' )}}
			<span class="by-info" *ngIf="item?.brand?.address?.city">- {{item?.brand?.address?.city}}</span>
		</p>
	</div> -->
<!-- <div class="col-xs-12 col-sm-12 col-md-12 compare-like-block"> -->
<!-- <div class="col-xs-7 col-sm-7 col-md-7 text-center px-0 add-to-compare-block">
			<app-light-checkbox [text]="'Add to Compare'" [checked]="isItemIncludedInCompareList(item)"
				(click)="$event.stopPropagation()"
				(onChangeEvent)="addRemoveCompareItem($event, item)"></app-light-checkbox>
		</div> -->
<!-- <div class="col-xs-4 col-sm-8 col-md-5 col-lg-4 col-xl-2 px-0 comment-like-block">
			<div id="newItem" class="col-xs-6 col-sm-6 col-md-6 comment-block px-0"
				(click)="!IsWishList && doComment($event, item)">
				<span>{{(item.review && item.review.length) ? item.review.length : 0}}</span>
				<mat-icon svgIcon="comment" class="icon-size-16"></mat-icon>
			</div>
			<div id="newItem" class="col-xs-6 col-sm-6 col-md-6 like-block px-0"
				(click)="!IsWishList && doLike($event, item)">
				<span>{{(item.likes && item.likes.length) ? item.likes.length : 0}}</span>
				<mat-icon [svgIcon]="isLike ? 'heart-filled' : 'heart-empty'" class="icon-size-16"></mat-icon>
			</div>
		</div> -->
<!-- <div class=""></div>
</div>
</div> -->

<div class="item_tile_data">
	<div class="card">
		<div class="card_img">
			<div class="cardImg">
				<img [src]="image" alt="{{item.name ? item.name : ''}}"
					onError="this.src='./assets/images/dummy/placeholderImage.jpg'" />
			</div>
			<div class="card_text">
				<h3 class="name">{{ item.name }}</h3>
				<p class="price-label">
					<span *ngIf="getPrice(item)[1]" for="finalDiscountedPrice">{{getPrice(item)[1] |
						currency:'INR':'symbol-narrow':'1.2-2'}}</span>
					<span [class.strikeThrough]="getPrice(item)[1]" for="finalActualPrice">{{getPrice(item)[0] |
						currency:'INR':'symbol-narrow':'1.2-2'}}</span>
				</p>
				<p class="by-info" *ngIf="item?.brand?.name">
					{{getShortenedBrandName(item.brand.name || '' )}}
					<!-- <span class="by-info" *ngIf="item?.brand?.address?.city">- {{item?.brand?.address?.city}}</span> -->
					<span class="by-info" *ngIf="item?.brand?.address?.city">- {{item.brand.address.city ?
						item.brand.address.city : ''}}</span>
				</p>
			</div>
		</div>

	</div>
</div>